var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.499 51.549L47.644 65.69a3.33 3.33 0 004.713 0l14.145-14.141-4.717-4.713-8.451 8.451V20h-6.666v35.287l-8.454-8.451-4.715 4.713z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.333 60v13.334H26.667V60H20v13.334C20 76.998 23.001 80 26.667 80h46.666C76.999 80 80 76.998 80 73.334V60h-6.667z"
  })));
}
export default SvgDownload;